import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { ChevronUp } from 'react-bootstrap-icons';
import HomeBanner from '../components/HomeBanner';
import Navigation from '../components/Navigation';
import AboutUs from '../components/AboutUs';
import Client from '../components/Clients';
import Work from '../components/Work';
import Services from '../components/Services';
import Process from '../components/Process';
import GetStarted from '../components/GetStarted';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* <div className="hero-gradient">
        <Navigation />
        <HomeBanner />
      </div> */}

      <AboutUs />
      <GetStarted />
      <Services />
      <Process />
      <Client />
      <Work />
      <Contact />
      
    </>
  );
}

export default Home;